import {
  FETCH_NOTIFICATIONS,
  FETCH_NOTIFICATIONS_COUNT,
} from "../../constants/action.constants";

const initialState = {
  list: [],
  others: {},
  countData: [],
};

const notificationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_NOTIFICATIONS:
      return { ...state, list: action.payload, others: action.others };
    case FETCH_NOTIFICATIONS_COUNT:
      return { ...state, countData: action.payload };
    default:
      return state;
  }
};

export default notificationsReducer;
